import React, { useEffect, useState } from 'react';
import { Layout, Skeleton, Empty, notification } from 'antd';
import { Content } from 'antd/es/layout/layout';
import axiosInstance from '../../../../axios_instance';
import PaginationComponent from '../../../general/pagination';
import CertificationReportList from '../../../uicontainers/admin/certification-report-list';
import styles from './styles.module.scss';

const CertificationReportView: React.FC = (): JSX.Element => {
  const [reportList, setReportList] = useState<Array<any>>([]);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);

    axiosInstance
      .get(`/api/v1/admin/reports/certifications?page-number=${page}&page-size=${pageSize}`)
      .then((response) => {
        if (isMounted) {
          setReportList(response.data?.items || []);
          setTotal(response.data?.total_items || 0);
        }
      })
      .catch(() => {
        if (isMounted) {
          notification.error({
            message: 'Failed to load certification report',
            description: 'Please check your connection or try again later.',
          });
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [page, pageSize]);

  return (
    <>
      <h1 className={styles['page-title']}>Certification Reports</h1>
      <Layout className={styles.layout}>
        <Content className={styles.container}>
          {isLoading ? (
            <div style={{ padding: '24px' }}>
              <Skeleton active paragraph={{ rows: 8 }} />
            </div>
          ) : reportList.length === 0 ? (
            <div style={{ padding: '40px 0' }}>
              <Empty description="No employee certifications found" />
            </div>
          ) : (
            <CertificationReportList reportList={reportList} />
          )}

          {total > pageSize && (
            <div className={styles['pagination-container']}>
              <PaginationComponent
                pageNumber={page}
                total={total}
                setPageNumber={setPage}
                pageSize={pageSize}
              />
            </div>
          )}
        </Content>
      </Layout>
    </>
  );
};

export default CertificationReportView;
